import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { Skeleton } from '@factorialco/deprecated-design-system'
import { PerformanceTemplateQuestionnairePreviewDocument } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { QuestionnairePreview } from 'modules/performance_process/components/questionnaire/QuestionnairePreview'

export const CustomTemplateQuestionnairePreviewSidepanel: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const { templateId } = useParams()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(PerformanceTemplateQuestionnairePreviewDocument, {
    variables: {
      templateId: Number(templateId),
      companyId: company.id,
    },
  })

  const template = data?.performance.reviewProcessCustomTemplate
  const isLegacyJobCatalogEnabled =
    data?.features?.featuresConnection.nodes.find(
      (featureFlag) => featureFlag.name === 'legacy_job_catalog'
    )?.enabled ?? false
  const isJobCatalogTreeEnabled = !isLegacyJobCatalogEnabled

  return (
    <Sidepanel
      open={isOpen}
      onClose={onClose}
      width="wideXL"
      title={i18n.t('performance_process.reviews.preview_title')}
    >
      {loading ? (
        <Skeleton isLoading height="full" />
      ) : (
        <QuestionnairePreview
          reviewType={template?.reviewerStrategies ?? []}
          questionnaires={template?.questionnaires ?? undefined}
          isCompetenciesAssessmentsEnabled={template?.competenciesAssessmentsEnabled ?? false}
          scoreConfiguration={template?.scoreConfiguration}
          scoreScale={template?.scoreScale.scale ?? []}
          isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
        />
      )}
    </Sidepanel>
  )
}
